import React from 'react';
import { HeroSection } from './HeroSection';
import { EmotionalHook } from './EmotionalHook';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { MidPageCTA } from './MidPageCTA';
import { BeforeAfterSection } from './BeforeAfterSection';
import { ForYouSection } from './ForYouSection';
import { ComparisonSection } from './ComparisonSection';
import { OriginStory } from './OriginStory';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { IncludesSection } from './IncludesSection';
import { GuaranteeSection } from './GuaranteeSection';
import { FinalCTA } from './FinalCTA';
import { PurchaseNotification } from './PurchaseNotification';
import { motion } from 'framer-motion';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FDF8F4] font-sans" data-id="element-248">
      {/* Announcement Bar */}
      <div className="relative overflow-hidden bg-gradient-to-r from-red-600 via-rose-500 to-red-600 text-white text-center py-3 text-sm font-bold tracking-wide" data-id="element-249">
        <motion.div animate={{
        backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent bg-[length:200%_100%]" data-id="element-250" />
        <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-251">
          🔥 77% DE DESCUENTO HOY + 2 BONOS INCLUIDOS 🔥
        </span>
      </div>

      <HeroSection data-id="element-252" />
      <EmotionalHook data-id="element-253" />
      <ProblemSection data-id="element-254" />
      <SolutionSection data-id="element-255" />
      <MidPageCTA data-id="element-256" />
      <BeforeAfterSection data-id="element-257" />
      <ForYouSection data-id="element-258" />
      <ComparisonSection data-id="element-259" />
      <OriginStory data-id="element-260" />
      <TestimonialsSection data-id="element-261" />
      <FAQSection data-id="element-262" />
      <IncludesSection data-id="element-263" />
      <GuaranteeSection data-id="element-264" />
      <FinalCTA data-id="element-265" />

      <PurchaseNotification data-id="element-266" />

      <footer className="bg-[#9B4D4D] text-white/60 py-12 text-center text-sm" data-id="element-267">
        <div className="max-w-7xl mx-auto px-4" data-id="element-268">
          <p data-id="element-269">© 2026 Calma-5™. Todos los derechos reservados.</p>
          <div className="mt-4 flex justify-center gap-6" data-id="element-270">
            <a href="#" className="hover:text-white transition-colors" data-id="element-271">
              Términos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-272">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-273">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </div>;
}